import React from "react"
import FinleyIconName from "../../../assets/FinleyIconName";
import { Divider } from "../../Catalyst/divider";

interface UserRecord {
    first: string
    last: string
    email: string
}

export interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    users: Array<UserRecord>;
}

const ConfirmUsersRemovalModal: React.FC<ModalProps> = ({ isOpen, onClose, onConfirm, users }) => {
    if (!isOpen) return null;
    console.log(users)
    return (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 rounded-2xl">
            <div className="bg-white w-[700px] h-[427px] rounded-xl shadow-xl p-6 animate-fadeIn flex flex-col justify-between">
                <div className="flex flex-col gap-4">
                <div className="flex justify-between items-start">
                    <FinleyIconName />
                    <button onClick={onClose} className="text-neutral-900 px-4 py-2 rounded-lg border border-neutral-200 desktext15 h-10">
                        Close
                    </button>
                </div>
                <div className="flex flex-col gap-2">
                <h3 className="desktext14 text-slate-900">Confirm Users Removal</h3>
                <p className="text8 text-textColor mt-1">
                    You’re about to remove users who are no longer in the current eligibility file.
                </p>
                </div>
                {/* Table */}
                {users.length > 0 && (
                    <div className="border w-full border-gray-200 rounded-xl max-h-[148px] overflow-y-auto table-auto border-collapse">
                        <table className="w-full">
                            <thead>
                                <tr className="">
                                    <th className="p-4 text-left text-textBodySerif desktext15">Name</th>
                                    <th className="p-4 text-left text-textBodySerif desktext15">Email</th>
                                    <th className="p-4 text-left text-textBodySerif desktext15">Status</th>
                                </tr>
                            </thead>

                            {/* Divider under header */}
                            <tbody>
                                <tr>
                                    <td colSpan={3} className="px-4">
                                        <div className="w-full h-px bg-gray-200"></div>
                                    </td>
                                </tr>

                                {/* Rows */}
                                {users.map((user, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        {/* NAME */}
                                        <td className="p-4">
                                            <div className="flex items-center gap-3">
                                                <span className="desktext16 text-neutral-700">
                                                    {(user.first || '-') + ' ' + (user.last || '-')}
                                                </span>
                                            </div>
                                        </td>

                                        {/* EMAIL */}
                                        <td className="p-4 desktext16 text-neutral-600">
                                            {user.email}
                                        </td>

                                        {/* STATUS */}
                                        <td className="p-4">
                                            <div className="flex items-center gap-2 desktext16 text-neutral-700">
                                                <span className="w-[10px] h-[10px] rounded-full bg-[#FF1A1A]"></span>
                                                To be removed
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <p className="text-neutral-600 desktext16">
                    Removed users will lose access immediately. You can re-invite them anytime with a new CSV upload.
                </p>
                </div>
                {/* Footer */}
                <div className="flex justify-between gap-3">
                    <button
                        onClick={onClose}
                        className="text-neutral-900 px-4 py-2 rounded-lg border border-neutral-200 desktext13 h-10"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded-lg bg-black text-white desktext13 h-10"
                        disabled={users.length === 0}
                    >
                        Confirm & Remove Users
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmUsersRemovalModal;
